<h4>Hours Undertaken on Placement</h4>

<table>
  <thead>
  <tr>
    <th></th>
    <th>Client Contact</th>
    <th>Individual Supervision</th>
    <th>Group Supervision</th>
<!--    <th>Total Supervision</th>-->
    <th>Other Activities</th>
    <th>Total Hours</th>
  </tr>
  </thead>
  <tbody>
  <tr>
    <th>Target Hours</th>
    <td>{{assessment?.client_contact_target_hours}}</td>
    <td>{{assessment?.individual_supervision_target_hours}}</td>
    <td>{{assessment?.group_supervision_target_hours}}</td>
    <td>{{assessment?.other_activities_target_hours}}</td>
    <td>{{assessment?.total_target_hours}}</td>
  </tr>
  <tr>
    <th>Actual hours</th>
    <td>
      <div class="k-form-field d-flex flex-column w-100">
          <input type="number" id="client_contact_hours" formControlName="client_contact_hours"
                 class="form-control" min="0" step="0.1" style="text-align: center">
          <div *ngIf="getControl('client_contact_hours')?.invalid" class="alert alert-danger custom-alert">
            <div *ngIf="getControl('client_contact_hours')?.errors?.['required']">It's required</div>
            <div *ngIf="getControl('client_contact_hours')?.errors?.['min'] || getControl('client_contact_hours')?.errors?.['pattern']">
              Only positive numbers with up to 1 decimal allowed.
            </div>
          </div>
      </div>
    </td>
    <td>
      <div class="k-form-field d-flex flex-column w-100">
        <input type="number" id="individual_supervision_hours" formControlName="individual_supervision_hours"
               class="form-control" min="0" step="0.1" style="text-align: center">
        <div *ngIf="getControl('individual_supervision_hours')?.invalid" class="alert alert-danger custom-alert">
          <div *ngIf="getControl('individual_supervision_hours')?.errors?.['required']">It's required</div>
          <div *ngIf="getControl('individual_supervision_hours')?.errors?.['min'] || getControl('individual_supervision_hours')?.errors?.['pattern']">
            Only positive numbers with up to 1 decimal allowed.
          </div>
        </div>
      </div>
    </td>
    <td>
      <div class="k-form-field d-flex flex-column w-100">
        <input type="number" id="group_supervision_hours" formControlName="group_supervision_hours"
               class="form-control" min="0" step="0.1" style="text-align: center">
        <div *ngIf="getControl('group_supervision_hours')?.invalid" class="alert alert-danger custom-alert">
          <div *ngIf="getControl('group_supervision_hours')?.errors?.['required']">It's required</div>
          <div *ngIf="getControl('group_supervision_hours')?.errors?.['min'] || getControl('group_supervision_hours')?.errors?.['pattern']">
            Only positive numbers with up to 1 decimal allowed.
          </div>
        </div>
      </div>
    </td>
    <td>
      <div class="k-form-field d-flex flex-column w-100">
        <input type="number" id="other_activities_hours" formControlName="other_activities_hours"
               class="form-control" min="0" step="0.1" style="text-align: center">
        <div *ngIf="getControl('other_activities_hours')?.invalid" class="alert alert-danger custom-alert">
          <div *ngIf="getControl('other_activities_hours')?.errors?.['required']">It's required</div>
          <div *ngIf="getControl('other_activities_hours')?.errors?.['min'] || getControl('other_activities_hours')?.errors?.['pattern']">
            Only positive numbers with up to 1 decimal allowed.
          </div>
        </div>
      </div>
    </td>
    <td><input type="number" formControlName="total_hours" class="form-control" readonly style="text-align: center"></td>
  </tr>
  </tbody>
</table>
